<template>
  <el-tooltip class="item" :effect="effect" :content="content" :placement="placement">
    <div slot="content">
      <slot name="content"></slot>
    </div>
    <slot name="btn"></slot>
  </el-tooltip>
</template>
<script>
import { Tooltip } from 'element-ui'
export default {
  name:'tooltipBox',
  props:{
    content:{
      type:String,
      default:''
    },
    effect:{
      type:String,
      default:'dark'
    },
    placement:{
      type:String,
      default:'top'
    }
  },
  data(){
    return {

    }
  },
  components:{
    elTooltip: Tooltip
  }
}
</script>


// WEBPACK FOOTER //
// src/components/tooltipBox.vue